// 统一请求路径前缀在commmon/axios.js中修改
import {
  postDemo,
  getDemo,
  deleDemo,
  deleDemos,
  getRequest,
  postRequest,
  postRequestLogin,
  putRequest,
  putNoToken,
  getRequestWithNoToken,
  deleteRequest,
} from "../assets/js/api";

// 修改手机号
export const _changePhone = (params) => {
  return postRequest("/api-system/users/changePhone", params);
};

// 修改密码
export const _modifyPassword = (params) => {
  return postRequest("/api-system/users/modifyPassword", params);
};

// 分页查询用户的知情同意书列表
export const _contentPage = (params) => {
  return postRequest("/api-system/psyInformedConsent/content/page", params);
};

// 根据内容ID查询知情同意书内容
export const _contentId = (id, params) => {
  return getRequest(`/api-system/psyInformedConsent/content/${id}`, params);
};

// 退出
export const _loginOut = (params) => {
  return getRequest("/api-system/users/loginOut", params);
};
//注销账户
export const _cancel = (params) => {
  return postRequest("/api-system/users/cancel", params);
};
//我的订单
export const _orderList = (params) => {
  return postRequest("/api-order/order/systysmC/pageList", params);
};
// 订单详情
export const _orderDetail = (params) => {
  return getRequest("/api-order/order/detail", params);
};
//线下课程申请退款
export const _applyRefund = (params) => {
  return postRequest("/api-order/order/applyRefund", params);
};
//线下课程撤销退款
export const _cancelApplyRefund = (params) => {
  return postRequest("/api-order/order/cancelApplyRefund", params);
};
//线下课程修改开课时间
export const _modifyCourseOrder = (params) => {
  return postRequest("/api-order/order/modifyCourseOrder", params);
};
//产品是否存在已支付的订单
export const _exsitPaidOrders = (params) => {
  return getRequest("/api-order/order/exsitPaidOrders", params);
};
//产品是否存在未支付的订单
export const _exsitUnpaidOrders = (params) => {
  return getRequest("/api-order/order/exsitUnpaidOrders", params);
};
//取消订单
export const _cancelOrder = (params) => {
  return getRequest("/api-order/order/cancelOrder", params);
};
//创建订单信息
export const _createOrder = (params) => {
  return postRequest("/api-order/order/createOrder", params);
};
//订单修改地址
export const _modifyOrderAddress = (params) => {
  return postRequest("/api-order/order/modifyOrderAddress", params);
};
//发票列表
export const _invoiceList = (params) => {
  return postRequest("/api-order/invoice/systysmC/pageList", params);
};
//申请开票
export const _applyInvoice = (params) => {
  return postRequest("/api-order/invoice/apply", params);
};
// 发邮箱
export const _sendEmail = (params) => {
  return getRequest("/api-order/invoice/sendEmail", params);
};
// 发票详情
export const _invoiceDetail = (params) => {
  return getRequest("/api-order/invoice/detail", params);
};
//取消开发票申请
export const applyCancel = (params) => {
  return postRequest("/api-order/invoice/applyCancel", params);
};
//下载发票
export const _downInvoice = (params) => {
  return getRequest("/api-file/file/downloadFile", params);
};
//获取我的地址列表
export const _addressList = (params) => {
  return getRequest("/api-customer/psy_shipping_address", params);
};
// 删除收货地址
export const _delAddress = (id) => {
  return deleteRequest("/api-customer/psy_shipping_address/" + id);
};
//新增收货地址
export const _addAddress = (params) => {
  return postRequest("/api-customer/psy_shipping_address", params);
};
//更改默认地址
export const _defaultAddress = (id) => {
  return putRequest("/api-customer/psy_shipping_address/defaultAddress/" + id);
};
//获取地址详情
export const _addressDetail = (id) => {
  return getRequest("/api-customer/psy_shipping_address/" + id);
};
//编辑地址
export const _editAddress = (id, params) => {
  return putRequest(`/api-customer/psy_shipping_address/${id}`, params);
};
//获取支付方式
export const _paymentMethodList = (params) => {
  return getRequest("/payment/orderPay/paymentMethodList", params).then(
    (res) => {
      if ("statusCode" in res) {
        res.code = res.statusCode;
      }
      if ("msg" in res) {
        res.message = res.msg;
      }
      return res;
    }
  );
};

//获取微信access_token
export const _payOrder = (params) => {
  return postRequest("/payment/orderPay/payOrder", params).then((res) => {
    if ("statusCode" in res) {
      res.code = res.statusCode;
    }
    if ("msg" in res) {
      res.message = res.msg;
    }
    return res;
  });
};

// 获取微信鉴权信息
export const _getWxTicketConf = (params) => {
  return getRequestWithNoToken("/payment/orderPay/getWxTicketConf", params);
};
// 获取微信用户openid
export const _getOpenidByCode = (params) => {
  return getRequestWithNoToken("/payment/orderPay/getOpenidByCode", params);
};
// 获取微信鉴权信息
export const _getWeChatAccessTokenInfo = (params) => {
  return getRequestWithNoToken(
    "/payment/orderPay/getWeChatAccessTokenInfo",
    params
  );
};
